import api from '@/api/api';

export default {
  update(id, updates) {
    return api.put(`business/${id}`, { updates });
  }
};
